import { useProductTranslations } from "../../hooks/TranslationHooks";
import FormattedPrice from "../FormattedPrice";
import { useProductPrice } from "../../hooks/ProductHooks";
import { divide } from "../../utils/NumberUtils";
import "./style.scss";
import { addVat } from "../../utils/VatUtils";
import useShowPricesWithVat from "../../hooks/useShowPricesWithVat";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";

const PriceArea = ({ product }) => {
  const features = useSiteFeatures();
  const tp = useProductTranslations();
  const showPricesWithVat = useShowPricesWithVat();
  const {
    hasPrice,
    basePrice,
    unitPrice,
    priceUnit,
    isPerSquareMeter,
    previousBasePrice,
    currency,
    unitQuantityFactor
  } = useProductPrice(product, false);

  const productBasePrice = basePrice ? (
    <FormattedPrice
      price={showPricesWithVat ? addVat(basePrice) : basePrice}
      sales_unit={priceUnit}
      currency={currency}
      price_class_name={!isPerSquareMeter ? "big-price" : null}
    />
  ) : null;
  const productUnitPrice =
    unitPrice && isPerSquareMeter ? (
      <FormattedPrice
        price={showPricesWithVat ? addVat(unitPrice) : unitPrice}
        price_class_name={"big-price"}
        price_unit={priceUnit}
        currency={currency}
      />
    ) : null;
  const previousUnitPrice =
    previousBasePrice > 0 && isPerSquareMeter ? (
      <FormattedPrice
        price={
          showPricesWithVat
            ? addVat(divide(previousBasePrice, unitQuantityFactor))
            : divide(previousBasePrice, unitQuantityFactor)
        }
        price_unit={priceUnit}
        currency={currency}
      />
    ) : null;

  return (
    hasPrice && (
      <div className={"prices"}>
        {productUnitPrice && (
          <div className={"unit-price"}>
            {productUnitPrice}
            {previousUnitPrice && (
              <div className={"previous-unit-price"}>
                {tp("previous_unit_price")}
                {previousUnitPrice}
              </div>
            )}
          </div>
        )}
        {(features.shop() || !productUnitPrice) && (
          <div className={"price"}>{productBasePrice}</div>
        )}
        <div className={"price-info"}>
          <>(</>
          {features.shop()
            ? showPricesWithVat
              ? tp("price_incl_vat")
              : tp("price_excl_vat")
            : showPricesWithVat
            ? tp("retail_price_incl_vat")
            : tp("retail_price_excl_vat")}
          <>)</>
        </div>
      </div>
    )
  );
};

export default PriceArea;
